import { IncomingMessage } from 'http';

import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import { fetchBrands } from '../../../services/vehicles';
import { getBrandsKey } from '../query-keys';

const getBrands = (
  options: {
    locale: string;
  },
  req?: IncomingMessage
): [
  QueryKey,
  (options: QueryFunctionContext) => ReturnType<typeof fetchBrands>
] => [
  getBrandsKey(options),
  ({ queryKey: [, locale] }: { queryKey: string[] }) =>
    fetchBrands({ locale }, req),
];

export default getBrands;
